import * as React from "react";
const SvgRadioDisabled = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill="#FAFAFA"
      stroke="#EAEAEA"
      strokeWidth={1.3}
      d="M22.35 12c0 5.716-4.634 10.35-10.35 10.35S1.65 17.716 1.65 12 6.284 1.65 12 1.65 22.35 6.284 22.35 12Z"
    />
  </svg>
);
export default SvgRadioDisabled;
